import React from 'react';
import SectionHeader from './SectionHeader';
import SectionLandscape from './SectionLandscape';
import SectionQuotes from './SectionQuotes';

export default function IndustrySection({ data, index }) {
  // Alternate background colors for visual separation, using the light sage tint
  const isEven = index % 2 === 0;
  const bgClass = isEven ? 'bg-white' : 'bg-sage-lightest';

  return (
    <section 
      id={data.id} 
      className={`py-24 md:py-32 ${bgClass} transition-colors duration-500`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <SectionHeader 
          title={data.title} 
          intro={data.intro} 
          buttonText={data.buttonText} 
          tagline={data.tagline} 
        />
        <SectionLandscape 
          landscapeTitle={data.landscapeTitle}
          landscapeText={data.landscapeText}
          solutionsTitle={data.solutionsTitle}
          solutions={data.solutions}
        />
        <SectionQuotes 
          understandTitle={data.understandTitle}
          understandText={data.understandText}
          alexTitle={data.alexTitle}
          alexText={data.alexText}
        />
      </div>
    </section>
  );
}